'use client';

import { PublicUserDocument, UserDocument } from 'models/user';
import { ChatDocument } from 'models/chat';
import SupportActionsRenderer from './SupportActionsRenderer';

type ChatSupportActionsProps = {
  userDoc: UserDocument | null | undefined;
  recipientDoc: PublicUserDocument | null | undefined;
  chat: ChatDocument;
  setChat: (chat: ChatDocument) => void;
};

export default function ChatSupportActions({
  userDoc,
  recipientDoc,
  chat,
  setChat,
}: ChatSupportActionsProps) {
  return (
    <SupportActionsRenderer
      layout="horizontal"
      userDoc={userDoc}
      recipientDoc={recipientDoc}
      chat={chat}
      setChat={setChat}
      isAdmin={userDoc?.roles?.admin || false}
      isSupport={userDoc?.roles?.support || userDoc?.roles?.admin || false}
    />
  );
}
